var map = {
	"./banner.jpg": "3787",
	"./banner_en.jpg": "a619",
	"./banner_es.jpg": "de91",
	"./banner_hk.jpg": "ce7b",
	"./banner_pt.jpg": "d6e7",
	"./banner_tr.jpg": "0f6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c50";